import { render, staticRenderFns } from "./Pacientes-comp.vue?vue&type=template&id=2c5d4306&scoped=true&"
import script from "./Pacientes-comp.vue?vue&type=script&lang=js&"
export * from "./Pacientes-comp.vue?vue&type=script&lang=js&"
import style0 from "./Pacientes-comp.vue?vue&type=style&index=0&id=2c5d4306&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5d4306",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCard,VCardText,VSnackbar,VTab,VTabItem,VTabs,VTabsSlider})
